import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DepartmentForm from '../../components/Departments/DepartmentForm';
import departmentService from '../../services/departmentService';
import './DepartmentPages.css';

const DepartmentEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [department, setDepartment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchDepartment();
  }, [id]);

  const fetchDepartment = async () => {
    try {
      const data = await departmentService.getDepartmentById(id);
      setDepartment(data.department);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch department');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="loading">Loading department...</div>;
  }

  if (error) {
    return (
      <div className="department-page">
        <div className="alert alert-danger">{error}</div>
        <button onClick={() => navigate('/app/departments')} className="btn btn-primary">
          Back to Departments
        </button>
      </div>
    );
  }

  return (
    <div className="department-page">
      <div className="page-header">
        <button onClick={() => navigate('/app/departments')} className="back-button">
          <i className="fas fa-arrow-left"></i> Back to Departments
        </button>
        <h1>Edit Department</h1>
      </div>
      <DepartmentForm departmentId={id} initialData={department} />
    </div>
  );
};

export default DepartmentEdit;


